(() => {
  const root = document.querySelector('[data-temple-sound]');
  if (!root) return;
  const audio = root.querySelector('[data-temple-audio]');
  const button = root.querySelector('[data-sound-toggle]');
  const label = root.querySelector('[data-sound-label]');
  const title = root.querySelector('[data-sound-title]');
  const volume = root.querySelector('[data-sound-volume]');
  const choice = root.querySelector('[data-sound-choice]');
  const status = root.querySelector('[data-sound-status]');
  const key = 'vedora-temple-sound-v3';
  let pref = { volume: 18, position: 0, track: 'mixed' };
  try { pref = { ...pref, ...JSON.parse(localStorage.getItem(key) || '{}') }; } catch (_) {}
  pref.volume = Math.max(0, Math.min(100, Number(pref.volume) || 0));
  if (!['mixed', 'conch', 'bells'].includes(pref.track)) pref.track = 'mixed';
  audio.volume = pref.volume / 100;
  volume.value = pref.volume;
  choice.value = pref.track;
  let resumeVisible = false;
  let stopped = false;
  // Stop is intentionally page-local: a fresh load attempts autoplay again.
  delete pref.enabled;
  const save = () => {
    if (audio.readyState > 0 && Number.isFinite(audio.currentTime)) pref.position = audio.currentTime;
    try { localStorage.setItem(key, JSON.stringify(pref)); } catch (_) {}
  };
  const update = () => {
    const playing = !audio.paused && !audio.ended;
    const text = 'Stop Sound';
    button.disabled = stopped;
    button.removeAttribute('aria-pressed');
    button.setAttribute('aria-label', text + ': ' + title.textContent);
    label.textContent = text;
    root.classList.toggle('is-playing', playing);
  };
  const setTrack = () => {
    const option = choice.selectedOptions[0];
    audio.src = option.dataset.src;
    title.textContent = option.textContent;
    update();
  };
  audio.addEventListener('loadedmetadata', () => {
    if (Number.isFinite(audio.duration) && Number(pref.position) > 0) {
      audio.currentTime = Math.min(Number(pref.position), Math.max(0, audio.duration - .1));
    }
  });
  audio.addEventListener('play', update);
  audio.addEventListener('pause', update);
  audio.addEventListener('error', () => { status.textContent = root.dataset.errorLabel; update(); });
  const play = async () => {
    if (stopped || document.hidden) return;
    status.textContent = '';
    try {
      await audio.play();
      if (stopped || document.hidden) audio.pause();
      update();
    }
    catch (error) {
      update();
      if (!stopped) status.textContent = error.name === 'NotAllowedError' ? 'Your browser blocked automatic sound playback.' : root.dataset.errorLabel;
    }
  };
  button.addEventListener('click', () => {
    stopped = true;
    resumeVisible = false;
    audio.pause();
    status.textContent = 'Sound stopped. Refresh the page to try playing again.';
    update();
    save();
  });
  choice.addEventListener('change', () => {
    const wasPlaying = !audio.paused;
    audio.pause();
    pref.track = choice.value;
    pref.position = 0;
    setTrack();
    save();
    if (wasPlaying) play();
  });
  volume.addEventListener('input', () => { pref.volume = Number(volume.value); audio.volume = pref.volume / 100; save(); });
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) { resumeVisible = !audio.paused; audio.pause(); save(); }
    else if (resumeVisible && !stopped) { resumeVisible = false; play(); }
  });
  window.addEventListener('pagehide', save);
  setTrack();
  if (!document.hidden) play();
  else resumeVisible = true;
})();
